import { useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { Link } from "react-router-dom";
import { useLanguage } from "../config/language/LanguageContext";

export default function ContactUs() {
  const { locale } = useLanguage();
  const [agree, setAgree] = useState(false);

  const onSubmit = async (event) => {
    event.preventDefault();
    const form = event.target;

    if (!agree) {
      toast.error(locale.CONTACT.toast.requiredConsent);
      return;
    }

    const formData = new FormData(form);
    const accessKey = process.env.REACT_APP_ACCESS_KEY;

    formData.append("access_key", accessKey);
    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    toast.loading(locale.CONTACT.toast.submitting);

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: json,
      });
      const res = await response.json();

      toast.dismiss();

      if (res.success) {
        toast.success(locale.CONTACT.toast.success);
        form.reset();
        setAgree(false);
      } else {
        toast.error(locale.CONTACT.toast.fail);
      }
    } catch (error) {
      toast.dismiss();
      toast.error(locale.CONTACT.toast.error);
    }
  };

  return (
    <section id="contact-section" className="py-16 bg-gray-50">
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            fontSize: "1.1rem",
            padding: "18px 24px",
            border: "2px solid #FF9E0C",
            background: "#fff",
            color: "#333",
          },
          iconTheme: {
            primary: "#FF9E0C",
            secondary: "#fff",
          },
          duration: 5000,
        }}
      />
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center px-6 md:px-12">
        <div className="overflow-hidden rounded-xl shadow-lg">
          <iframe
            title="location map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2643.0508352033503!2d-0.1373624617803413!3d51.50425124663128!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48761b28e2e69f1f%3A0x5e7ff2721f6f9b33!2sLondon%2C%20United%20Kingdom!5e0!3m2!1sen!2sus!4v1640580873409!5m2!1sen!2sus"
            width="100%"
            height="400"
            allowFullScreen=""
            loading="lazy"
            className="rounded-xl"
          ></iframe>
        </div>

        <div>
          <h2 className="text-3xl font-semibold text-gray-800">{locale.CONTACT.heading}</h2>
          <p className="text-gray-500 mt-2">
            {locale.CONTACT.subheading}
          </p>

          <form className="mt-6 space-y-4" onSubmit={onSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">
                  {locale.CONTACT.firstName}
                </label>
                <input
                  name="firstName"
                  type="text"
                  placeholder={locale.CONTACT.firstNamePlaceholder}
                  className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-orange-400 focus:border-orange-400 transition"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">
                  {locale.CONTACT.lastName}
                </label>
                <input
                  name="lastName"
                  type="text"
                  placeholder={locale.CONTACT.lastNamePlaceholder}
                  className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-orange-400 focus:border-orange-400 transition"
                  required
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">
                {locale.CONTACT.email}
              </label>
              <input
                name="email"
                type="email"
                placeholder={locale.CONTACT.emailPlaceholder}
                className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-orange-400 focus:border-orange-400 transition"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">
                {locale.CONTACT.message}
              </label>
              <textarea
                name="message"
                placeholder={locale.CONTACT.messagePlaceholder}
                rows="4"
                className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-orange-400 focus:border-orange-400 transition"
                required
              ></textarea>
            </div>

            <div className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={agree}
                onChange={(e) => setAgree(e.target.checked)}
                className="h-4 w-4 text-orange-500 border-gray-300 rounded focus:ring-orange-400"
              />
              <span className="text-sm text-gray-600">
                {locale.CONTACT.privacyConsent}{" "}
                <Link
                  target="_blank"
                  rel="noopener noreferrer"
                  to="/privacy-policy"
                  className="text-orange-500 underline hover:text-orange-600"
                >
                  {locale.CONTACT.privacyPolicy}
                </Link>
              </span>
            </div>

            <button
              type="submit"
              className="w-full bg-orange-500 text-white py-3 rounded-lg font-semibold hover:bg-orange-600 transition cursor-pointer"
            >
              {locale.CONTACT.submitButton}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
